<div
  class="absolute flex h-28 flex-row items-end"
  [style.left.px]="absoluteTableRect().x[0]"
  [style.bottom.px]="dimension.height - absoluteTableRect().y[0] + 8"
  [style.width.px]="absoluteTableRect().x[1] - absoluteTableRect().x[0]">
  @for (line of tableData.lines.vertical(); track $index) {
    @if ($index < tableData.lines.vertical().length - 1) {
      <ct-extraction-table-overlay-column-assignment-item
        [columnWidth]="
          (tableData.lines.vertical()[$index + 1].offset() - line.offset()) * dimension.width
        "
        [tableData]="tableData"
        [columnIndex]="$index"
        [isMenuOpened]="openedMenuIndex === $index"
        (isMenuOpenedChange)="!$event && closeOpenedMenu()"
        (columnButtonClicked)="openMenuIfTableDataIsNotConfirmedAndCloseMenuIfOpened($event)"
        (newTableHeaderAtColumnPosition)="
          setNewTableHeaderAtColumnPosition($index, $event.columnKey)
        "
        [tableColumnLabelsByKeys]="tableColumnLabelsByKeys()" />
    }
  }
</div>
